import React from 'react';
import _ from 'lodash';

import DropdownDisplay from '../dropdown-display.jsx';
import DropdownList from '../dropdown-list.jsx';
import Option from '../option';

const LabelDropdown = (props) => {
  const generateOptionList = (optionList) => {
    if (_.isEmpty(optionList)) {
      return null;
    }

    return _.map(optionList, (option, index) => {
      const className = option.className || '';

      return (
        <Option
          className={className}
          onClick={props.changeHandler}
          style={option.style}
          value={option.value}
          selected={option.selected}
          key={index}
        >
          {option.label}
        </Option>
      );
    });
  };

  return (
    <div>
      <DropdownDisplay clickHandler={props.toggleDropdown}>
        <span style={props.selectedLabelStyle}>{props.label}</span>
      </DropdownDisplay>

      <DropdownList open={props.open}>
        {generateOptionList(props.options)}
      </DropdownList>
    </div>
  );
};


LabelDropdown.propTypes = {
  open: React.PropTypes.bool,
  toggleDropdown: React.PropTypes.func,
  label: React.PropTypes.string,
  selectedLabelStyle: React.PropTypes.object,
  options: React.PropTypes.array,
  changeHandler: React.PropTypes.func
};

export default LabelDropdown;



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-types/label-dropdown.jsx